import { Text } from './BEText';
export default Text;
